import * as React from 'react';

export default function renderMeetingPreviewPlaceHolder(): JSX.Element {
    return <span>&nbsp;</span>;
}
